import "swiper/css";
import Swiper from "swiper";

const sliders = document.querySelectorAll(".logo-strip-swiper");

sliders.forEach((slider, index) => {
  slider.classList.add(`logo-strip-swiper-${index}`);
  const isFullWidth = slider.dataset.layout === "full-width";

  new Swiper(`.logo-strip-swiper-${index}`, {
    slidesPerView: isFullWidth ? 3 : 3.5,
    spaceBetween: isFullWidth ? 16 : 16,
    loop: true,
    speed: 500,
    breakpoints: isFullWidth
      ? {
          576: { slidesPerView: 1.8, spaceBetween: 32 },
          768: { slidesPerView: 2.4, spaceBetween: 32 },
          992: { slidesPerView: 3, spaceBetween: 40 },
          1200: { slidesPerView: 3.6, spaceBetween: 40 },
          1600: { slidesPerView: 4.6, spaceBetween: 40 },
          1920: { slidesPerView: 5.6, spaceBetween: 40 },
        }
      : {
          576: { slidesPerView: 5, spaceBetween: 16 },
          768: { slidesPerView: 7, spaceBetween: 20 },
          992: { slidesPerView: 8, spaceBetween: 24 },
          1200: { slidesPerView: 10, spaceBetween: 24 },
        },
  });
});
